import { Component, OnInit } from "@angular/core";
import { BreadcrumbService } from '../../app.breadcrumb.service';
import { MessageService, ConfirmationService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Router, ActivatedRoute } from '@angular/router';
import { BaseComponent } from 'src/app/base/base-component';
import { DonneesBaseService } from 'src/app/services/donnees-base-service';
import { ProfilService } from 'src/app/services/profil-service';
import { AppMainComponent } from 'src/app/app.main.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AchatService } from "src/app/services/achat-service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";

@Component({
    templateUrl: './general.component.html',
    styleUrls: ['./general.component.scss'],
    providers: [MessageService, ConfirmationService, DialogService]
})
export class GeneralComponent extends BaseComponent implements OnInit {

    uploadedFiles: any[] = [];
    pdfTermesPaiementUrl: SafeResourceUrl;
    uploadUrl: string = '';
    loading: boolean = false;

    constructor(
        sdb: DonneesBaseService,
        profilService: ProfilService,
        route: ActivatedRoute,
        appMain: AppMainComponent,
        private breadcrumbService: BreadcrumbService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        public dialogService: DialogService,
        public routerService: Router,
        private http: HttpClient,
        private achatService: AchatService,
        private sanitizer: DomSanitizer
    ) {
        super(sdb, profilService, route, routerService, appMain);

        this.breadcrumbService.setItems([
            { label: 'Administration', routerLink: '/admin' },
            { label: 'Général', routerLink: '/admin/general' }
        ]);
    }

    ngOnInit() {
        this.chargerPdfTermesPaiement();
        this.uploadUrl = environment.apiBaseUrl + 'achat/bonsCommande/termesPaiment';
        this.CompleterChargement();
    }

    chargerPdfTermesPaiement() {
        this.loading = true;
        this.achatService.ObtenirTermesPaiementPdf().subscribe(
            (pdf: Blob) => {
                // Revoke previous URL to prevent memory leaks
                if (this.pdfTermesPaiementUrl) {
                    URL.revokeObjectURL(this.pdfTermesPaiementUrl.toString());
                }
                
                // Create a new object URL with a timestamp to prevent caching
                const url = URL.createObjectURL(pdf) + '#t=' + new Date().getTime();
                this.pdfTermesPaiementUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
                this.loading = false;
            },
            error => {
                this.messageService.add({severity: 'error', summary: 'Erreur', detail: 'Échec de la récupération du PDF'});
                this.loading = false;
            }
        );
    }

    onUpload(event) {
        this.loading = true;
        this.achatService.AjouterTermesPaiementPdf(event.files[0]).subscribe(
            (message: string) => {
                this.messageService.add({severity: 'success', summary: 'Succès', detail: message});
                this.chargerPdfTermesPaiement();
            },
            error => {
                console.error('Error uploading PDF:', error);
                this.messageService.add({severity: 'error', summary: 'Erreur', detail: 'Échec du téléversement du PDF'});
                this.loading = false;
            }
        );
    }

    onFileSelect(event) {
    }

    onBeforeSend(event) {
        this.loading = true;
    }
    
    onError(event) {
        this.loading = false;
        this.messageService.add({severity: 'error', summary: 'Erreur', detail: 'Échec du téléversement du PDF'});
    }
} 